/** Shared world coordinates keep rendering and projectile travel in agreement. */
export const PLAYER_Z = 1.2;
export const OPPONENT_Z = -4.6;
export const PROJECTILE_DISTANCE = PLAYER_Z - OPPONENT_Z;
export const PROJECTILE_FLIGHT_SECONDS = PROJECTILE_DISTANCE / 8;
